var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.truncate(_vm.currentProject.name, {length: 15}))+"  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }